import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import ApplicantsTable from "./ApplicantsTable";
import { getJobApplications } from "../../../redux/features/careerSlice";

// Applicants for ONE job (reached by clicking a job row's "Applicants" button).
const JobApplicants = () => {
  const { jobId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { applicants, loading } = useSelector((state) => state.career);

  // load the applicants (+ unread counts) on mount / when the job changes;
  // no background polling
  useEffect(() => {
    dispatch(getJobApplications(jobId));
  }, [dispatch, jobId]);

  return (
    <GlobalWrapper
      title={"Applicants"}
      actions={
        <Button variant="outlined" size="small" onClick={() => navigate("/career-connect/jobs")}>
          Back to Jobs
        </Button>
      }
    >
      <ApplicantsTable
        rows={applicants?.data || []}
        counts={applicants?.meta?.counts || {}}
        loading={loading}
      />
    </GlobalWrapper>
  );
};

export default JobApplicants;
